module.exports = __webpack_public_path__ + "static/patryk-karczmarczyk-x1-3d06c1089a66509e1dba046d18da817b.jpg";